export class PrivacyPolicyFactory {
  public static readonly SECONDARY_PARTS = [
    [
      {title: 'privacy_policy_content.privacy_policy_title', description: 'privacy_policy_content.privacy_policy_description'}
    ],
    [
      {title: 'privacy_policy_content.introduction', description: 'privacy_policy_content.introduction_text', additionalDescription: 'privacy_policy_content.introduction_text_1'},
      {title: 'privacy_policy_content.information', description: 'privacy_policy_content.information_text'},
    ],
    [
      {title: 'privacy_policy_content.payments', description: 'privacy_policy_content.payment_description'},
      {title: 'privacy_policy_content.managing_information', description: 'privacy_policy_content.managing_information_description'},
      {title: 'privacy_policy_content.disclosure', description: 'privacy_policy_content.disclosure_text'},
      {title: 'privacy_policy_content.retention', description: 'privacy_policy_content.retention_text'},
      {title: 'privacy_policy_content.transfer', description: 'privacy_policy_content.transfer_info'},
      {title: 'privacy_policy_content.limited', description: 'privacy_policy_content.limited_text'},
      {title: 'privacy_policy_content.rights_of_users', description: 'privacy_policy_content.rights_of_users_text'},
      {title: 'privacy_policy_content.object_to_processing', description: 'privacy_policy_content.object_to_processing_text'},
      {title: 'privacy_policy_content.data_protection', description: 'privacy_policy_content.data_protection_text'},
      {title: 'privacy_policy_content.children', description: 'privacy_policy_content.children_text'},
      {title: 'privacy_policy_content.advertisements', description: 'privacy_policy_content.advertisements_text'},
      {title: 'privacy_policy_content.email', description: 'privacy_policy_content.email_text'},
      {title: 'privacy_policy_content.resources', description: 'privacy_policy_content.resources_text'},
      {title: 'privacy_policy_content.security', description: 'privacy_policy_content.security_text'},
      {title: 'privacy_policy_content.data_breach', description: 'privacy_policy_content.data_breach_text'},
      {title: 'privacy_policy_content.change', description: 'privacy_policy_content.change_text'},
      {title: 'privacy_policy_content.acceptance', description: 'privacy_policy_content.acceptance_text'}
    ],
  ]

  public static readonly PRIVACY_PRINCIPLES = [
    {title: 'privacy_policy_content.your_data', description: 'privacy_policy_content.your_data_text', class: 'mt-40px flex-direction-column'},
    {title: 'privacy_policy_content.secure_storage', description: 'privacy_policy_content.secure_storage_text', class: 'mt-20px flex-direction-column'},
    {title: 'privacy_policy_content.safe_sharing', description: 'privacy_policy_content.safe_sharing', class: 'mt-20px flex-direction-column'},
  ];
}
